import request from '@/router/axios'
import env from '@/config/env'
import qs from 'qs'

// 获取资产列表（分页）
export const queryInventoryPage = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/page',
    method: 'POST',
    data
  })
}

// 查询资产分类树
export const queryAssetKindTree = () => {
  return request({
    url: env.officeUrl + '/asset-kind/v1/tree-list',
    method: 'GET'
  })
}

// 查询部门树
export const queryDeptTree = () => {
  return request({
    url: env.officeUrl + '/department/tree/all',
    method: 'GET'
  })
}

// 发起资产盘点
export const addInventory = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/add',
    method: 'POST',
    data
  })
}

// 获取盘点状态
export const queryInventoryEnum = () => {
  return request({
    url: env.officeUrl + '/asset/inventory/enum',
    method: 'GET'
  })
}

// 关闭盘点
export const closeInventory = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/close?inventoryId=' + data.inventoryId,
    method: 'PUT'
  })
}

// 作废盘点
export const voidInventory = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/voidInventory?inventoryId=' + data.inventoryId,
    method: 'PUT'
  })
}

// 获取员工盘点进度（分页）
export const queryUserInventoryPage = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/user/page',
    method: 'POST',
    data
  })
}

// 获取盘点模式
export const queryInventoryMode = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/mode?' + qs.stringify(data),
    method: 'GET'
  })
}

// 变更盘点模式
export const changeInventoryMode = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/detail/changeMode?' + qs.stringify(data),
    method: 'PUT'
  })
}

// 获取盘点详情（分页）
export const queryInventoryDetailPage = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/detail/page',
    method: 'POST',
    data
  })
}

// 获取状态Tabs
export const queryInventoryDetailTabs = (data) => {
  return request({
    url: env.officeUrl + '/asset/inventory/detail/tabs?' + qs.stringify(data),
    method: 'GET'
  })
}
// 资产盘点确认分页
export const confirmPage = (params) => {
  return request({
    url: env.officeUrl + '/asset/inventory/confirm/page',
    method: 'post',
    data: params
  })
}

// 资产盘点确认分页
export const confirm = (params) => {
  return request({
    url: env.officeUrl + '/asset/inventory/confirm',
    method: 'post',
    data: params
  })
}
